<script>
export default {
  props: ["data"],
  data() {
    return {};
  },
};
</script>
<template>
  <div class="section-information section-space--inner--80">
    <div class="container">
      <div class="row row-25 align-items-center">
        <div class="col-lg-5 col-12 mb-30">
          <div v-if="data.image.length > 0" class="about-image-two">
            <img
              :src="data.image"
              class="rounded position-relative"
              alt="image"
              style="z-index: 10;"
            />
          </div>
          <div v-else class="about-image-two h-100">
            <img
              src="@/assets/images/global/list_empty.png"
              class="rounded position-relative"
              alt="image"
              style="z-index: 10;"
            />
          </div>
        </div>
        <div class="col-lg-7 col-12 mb-30">
          <div class="bg-home--pengumuman"></div>
          <div class="about-content-pengumuman position-relative">
            <br />
            <h3 class="text-white pt-5">
              <span class="span-hr-white">Pengumuman</span>
            </h3>
            <br />
            <h2 class="text-white">
              {{ data ? data.title : "Data belum tersedia" }}
            </h2>
            <div class="text-right show-info">
              <router-link
                to="/pengumuman"
                class="btn ht-btn-default--round mt-4 btn-primary-theme-white"
                >LIHAT INFO</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/scss/6-responsive/template-blue/index.scss";
</style>
